// export const types = {
//     toggleGalleryViewVisitors: 'toggleGalleryViewVisitors'
// }

export default {
    setOnlineUsers: (state, onlineUsers) => {
        console.log('setOnlineUsers', onlineUsers);
        state.onlineUsers = onlineUsers
    }
};